import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, ExternalLink } from 'lucide-react';

const GoogleReviews = () => {
  return (
    <section id="reviews" className="py-20 bg-gradient-to-b from-blue-50 to-white" data-testid="reviews-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <img
              src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/google.svg"
              alt="Google"
              className="h-8 w-8"
            />
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Google Reviews
            </h2>
          </div>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed">
            See what our customers are saying — and share your own experience with
            our authentic Filipino lumpia!
          </p>
        </div>

        {/* Google Business Profile CTA */}
        <Card className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white border-0 shadow-xl">
          <CardContent className="py-8 text-center">
            <h3 className="text-2xl font-bold mb-4">
              Read & Leave a Review on Google
            </h3>
            <p className="text-blue-100 mb-6 text-lg">
              Check out our reviews and help others discover authentic Filipino flavors
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://www.google.com/maps?cid=14030404432755284836"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center space-x-2 shadow-lg"
                data-testid="google-reviews-link"
              >
                <span>View Our Google Reviews</span>
                <ExternalLink className="h-4 w-4" />
              </a>
              <div className="flex items-center space-x-2 text-blue-100">
                <Star className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                <span className="font-medium">Loved your lumpia? Leave us a review!</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default GoogleReviews;
